import { PROFILE_SLUGS } from './profileSlugs';

const profileLabelMap: Record<string, string> = {
  [PROFILE_SLUGS.COACHING_CONVERSATION_SUMMARY]: 'Session Summary',
  [PROFILE_SLUGS.COACHING_CONVERSATIONS_SUMMARY]: 'Coaching Arc summary',
  [PROFILE_SLUGS.COACHING_FEEDBACK]: 'Coaching Reflection',
  [PROFILE_SLUGS.COACHING_FEEDBACK_ARC]: 'Coaching Reflection',
  [PROFILE_SLUGS.CHEM_CALL_REFLECTION]: 'Chem Call',
  [PROFILE_SLUGS.MEMBER_REFLECTION]: 'Member reflection',
  [PROFILE_SLUGS.CHEM_CALL_REFLECTION_MEMBER]: 'Member chemistry call reflection',
  [PROFILE_SLUGS.MEMBER_REFLECTION_ARC]: 'Member reflection',
  [PROFILE_SLUGS.SESSION_PREP_COACH]: 'Coach Session Prep',
  [PROFILE_SLUGS.SESSION_PREP_MEMBER]: 'Member Session Prep',
  [PROFILE_SLUGS.MILESTONES_AND_WINS]: 'Milestones and Wins',
  [PROFILE_SLUGS.DRIVE1ON1_SUMMARY]: 'Drive 1:1 summary',
};

export const getArtifactTypeLabel = (profileSlug: string): string => {
  const label = profileLabelMap[profileSlug];
  if (!label) {
    console.warn('[artifact] unknown profile slug for summary type label', { profileSlug });
    return 'Unknown artifact';
  }
  return label;
};
